import { useParams } from "react-router-dom";
import ModalAddEditCompetency from "../modal/modalAddEditCompetency";
import { useState } from "react";
import { detailTrainingTel2NewCompetency } from "../../../../config/apiSPA";
import ModalInfo from "../../../../components/modal/modalInfo";
const addCompetencyModalInitialState = {
  show: false,
  data: {
    trainingId: 2,
    kodeTrainingId: null,
    passingScore: null,
    remark: "",
  },
};

const confirmModalInitialState = {
  show: false,
  title: "Warning",
  text: "no Text",
  theme: "",
};

function TrainingEvaluasiLvl2Toolbar({ onUpdate = () => {} }) {
  const { id } = useParams();
  const [addCompetencyModalState, setAddCompetencyModalState] = useState(addCompetencyModalInitialState);
  const [confirmModalState, setCofirmModalState] = useState(confirmModalInitialState);
  const handleClickAddCompetency = () => {
    setAddCompetencyModalState((a) => ({ ...a, show: true, data: { ...a.data, trainingId: id } }));
  };
  const handleSubmitAddCompetency = async (e) => {
    setAddCompetencyModalState(addCompetencyModalInitialState);
    try {
      const res = await detailTrainingTel2NewCompetency(e);
      onUpdate(res.data);
    } catch (error) {
      setCofirmModalState({
        show: true,
        title: "Failed",
        text: `Failed to insert new competency : ${error.message}`,
        theme: "danger",
      });
    }
  };
  return (
    <>
      <div className="mb-2">
        <div className="d-block d-lg-flex align-items-center">
          <span onClick={handleClickAddCompetency} className="btn btn-outline-theme me-2 mb-1">
            <i className="fa fa-fw fa-plus"></i>
            <span>Add Comp..</span>
          </span>
        </div>
      </div>
      <ModalAddEditCompetency show={addCompetencyModalState.show} data={addCompetencyModalState.data} onHide={() => setAddCompetencyModalState(addCompetencyModalInitialState)} submitClick={(e) => handleSubmitAddCompetency(e)} />
      <ModalInfo
        show={confirmModalState.show}
        onHide={() => {
          setCofirmModalState((a) => ({ ...a, show: false }));
        }}
        title={confirmModalState.title}
        text={confirmModalState.text}
        theme={confirmModalState.theme}
        clicked={() => {
          setCofirmModalState((a) => ({ ...a, show: false }));
        }}
      />
    </>
  );
}

export default TrainingEvaluasiLvl2Toolbar;
